<template>
  <h2 class="text-xl font-semibold mb-4">Select Data Points</h2>
  <div v-if="loading" class="text-center">
    Loading data points...
  </div>
  <div v-else>
    <ul class="max-h-64 overflow-y-auto mb-4">
      <li v-for="dataPoint in sortedDataPoints" :key="dataPoint.id" class="flex items-center mb-2">
        <div v-if="dataPoint.value">
          <input
            type="checkbox"
            :id="'dataPoint-' + dataPoint.date"
            :value="dataPoint.date"
            v-model="selectedDataPointTimestamps"
            class="mr-2"
          />
          <label :for="'dataPoint-' + dataPoint.id" class="flex-1">
            {{ formatTimestamp(dataPoint.date) }} - Value: {{ dataPoint.value }} {{ dataPoint.units}}
          </label>
        </div>
      </li>
    </ul>
    <button
      @click="submitDataPoints"
      :disabled="selectedDataPointTimestamps.length === 0 || submitting"
      class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
    >
      {{ submitting ? 'Submitting...' : 'Submit Selected Data' }}
    </button>
    <div v-if="error" class="text-red-500 mt-2">
      {{ error }}
    </div>
    <div v-if="successMessage" class="text-green-500 mt-2">
      {{ successMessage }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'FoodBatchData',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    companyId: {
      type: String,
      required: true,
    },
    meterId: {
      required: true,
    },
    foodBatchId: {
      type: Number,
      required: true,
    },
    foodBatchCreatedAt: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dataPoints: [],
      loading: false,
      selectedDataPointTimestamps: [],
      submitting: false,
      error: '',
      successMessage: '',
    };
  },
  computed: {
    sortedDataPoints() {
      return this.dataPoints.sort((a, b) => new Date(b.date) - new Date(a.date));
    },
  },
  created() {
    this.resetState();
    this.fetchDataPoints();
  },
  methods: {
    openPanel() {
      this.$emit('update:isOpen', true);
      this.fetchDataPoints();
    },
    closePanel() {
      this.$emit('update:isOpen', false);
      this.resetState();
    },
    resetState() {
      this.dataPoints = [];
      this.selectedDataPointTimestamps = [];
      this.error = '';
      this.successMessage = '';
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleString();
    },
    async fetchDataPoints() {
      this.loading = true;
      this.error = '';
      try {

        const response = await axios.get(`/api-internal/${this.companyId}/data-meter/${this.meterId}`, {
          params: {
            startDate: this.foodBatchCreatedAt,
            useUTC: true,
          },
        });

        if (response.data) {
          this.dataPoints = response.data.data;
        } else {
          this.error = 'Failed to fetch data points.';
        }
      } catch (err) {
        this.error = 'An error occurred while fetching data points.';
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async submitDataPoints() {
      this.submitting = true;
      this.error = '';
      this.successMessage = '';
      try {
        // Fetch the selected data points details
        const selectedPoints = this.dataPoints.filter(dp => this.selectedDataPointTimestamps.includes(dp.date));
        // Prepare data to send
        const payload = {
          food_batch_id: this.foodBatchId,
          meterId: this.meterId,
          data_points: selectedPoints.map(dp => ({
            date: dp.date,
          })),
        };

        const response = await axios.patch( `/api-internal/${this.companyId}/food-batches/${this.foodBatchId}/food-batch-data`, payload);

        if (response.data.data.success) {
          this.successMessage = 'Data points successfully saved.';
          this.selectedDataPointTimestamps = [];
          // Force the window to refresh
          window.location.reload();
        } else {
          this.error = 'Failed to save data points.';
          console.log('failed to save data');
          console.log(response.data);
        }
      } catch (err) {
        if (err.response && err.response.data && err.response.data.errors) {
          this.error = Object.values(err.response.data.errors).flat().join(', ');
        } else {
          this.error = 'An error occurred while submitting data points.';
        }
        console.error(err);
      } finally {
        this.submitting = false;
      }
    },
  },
  watch: {
    meterId(newVal) {
      if (newVal) {
        this.fetchDataPoints();
      }
    },
  },
};
</script>

<style scoped>
/* Add any necessary styles for the slideover panel */
</style>
